<template>
  <div>
    <div class="guide-wrapper">
      <h2>Instrukcje do formularza</h2>
      <p class="h2-subtitle">Aby wygenerować kod doładowania licznika przedpłatowego:</p>

      <ol>
        <li>
          1. podaj <span>16 cyfrowy kod kreskowy</span> z Twojej karty klienta, przypisanej do punktu poboru energii,<br/>
          <img src="../../assets/images/form-guide.jpg" alt="Instrukcje do formularza">
        </li>
        <li>
          2. zadeklaruj <span>kwotę zakupu</span>
        </li>
        <li>
          3. zaakceptuj <span>regulamin</span>
        </li>
      </ol>

      <p>Na podany przez Ciebie adres email zostanie przesłany kod doładowania.</p>
      <p>Jeżeli podasz numer telefonu, kod doładowania otrzymasz w&nbsp;postaci sms.</p>
      <p class="last">
        Indywidualną kartę do dokonywania płatności możesz otrzymać
        w&nbsp;<span>Biurach Obsługi Klienta PGE Obrót S.A.</span>
      </p>
      <ul>
        <li>
          <a @click="showTutorialDialog" id="link-guide">Jak wypełnić formularz?</a>
        </li>
        <li>
          <a href="/files/pge/Regulamin-PGE.pdf" target="_blank" class="link-terms">Regulamin usługi</a>
        </li>
        <li>
          <a href="https://pomoc.autopay.pl/" target="_blank">Zgłaszanie reklamacji</a>
        </li>
        <li>
          <a @click="showExampleDialog" id="link-sample">Przykładowy formularz</a>
        </li>
        <li>
          <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" id="link-cookies">Polityka prywatności</a>
        </li>
      </ul>
    </div>

    <topup-guide-example :visible.sync="exampleDialogVisible"/>
    <topup-guide-tutorial :visible.sync="tutorialDialogVisible"/>
  </div>
</template>

<script>
import TopupGuideExample from '@/pge/components/Topup/GuideExample'
import TopupGuideTutorial from '@/pge/components/Topup/GuideTutorial'

export default {
  name: 'TopupGuide',
  components: {
    TopupGuideTutorial,
    TopupGuideExample
  },
  data: () => {
    return {
      exampleDialogVisible: false,
      tutorialDialogVisible: false
    }
  },
  methods: {
    showExampleDialog () {
      this.exampleDialogVisible = true
    },
    showTutorialDialog () {
      this.tutorialDialogVisible = true
    }
  }
}
</script>
